import { GwtExperimentsCfg } from "OK/GwtExperimentsCfg";

const handleLogging = () => {
    const gwtExperimentsCfg = GwtExperimentsCfg.getInstance();
    if (!gwtExperimentsCfg || !window.OK?.logging) {
        return;
    }


    /**
     * Получаем список используемых модулей.
     *
     * У requirejs есть контексты для одновременной работы с разными конфигами:
     * s - внутренний объект, который торчит наружу, в нём список контекстов,
     * _ - дефолтный контекст,
     * defined - список определённых модулей в этом контексте.
     *
     * */
    const allModules = Object.getOwnPropertyNames(window.require.s.contexts._.defined);
    const pattern = gwtExperimentsCfg.getModulesLoggingPattern();
    const filteredModules = allModules.reduce((result: Record<string, number>, moduleName) => {
        if (pattern?.test(moduleName)) {
            result[moduleName] = 1
        }

        return result;
    }, {});

    /**
     * Для отправки события, формируем объект вида:
     *
     * operation: {
     *     param1: count
     * }
     *
     * Приводим его к строке и присваиваем параметру "a" (см. one.widget.test.client.log.LogDataProvider.PARAM_LOG_AGG).
     *
     * Дальше вызов обрабатывается в one.app.community.dk.servlet.GwtLogServlet.logTree.
     *
     * По сути это аналог StatLogger.success("modules", moduleName), но реализованный через sendBeacon.
     * */
    window.OK.sendBeacon("/gwtlog", `a=${JSON.stringify({ modules: filteredModules })}`)

    window.removeEventListener("beforeunload", handleLogging)
}

export const activate = () => {
    const isLoggingModule = GwtExperimentsCfg.getInstance()?.isModulesLoggingEnabled();
    if (isLoggingModule) {
        window.addEventListener("beforeunload", handleLogging);
    }
}